import React, { useState } from "react";
import { Table, Button, Input, message } from "antd";
import { loginWithPassword } from "../api/checkmvd";
import { CopyOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const ConvertSPC = () => {
  const [data, setData] = useState([]); // Dữ liệu để hiển thị bảng
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(""); // Dữ liệu người dùng nhập

  // Hàm xử lý khi người dùng nhấn nút convert
  const handleConvert = async () => {
    const lines = inputValue.trim().split("\n"); // Tách từng dòng
    const result = [];
    setLoading(true);

    for (const line of lines) {
      const [username, password, spc_f] = line.split("|"); // Tách giá trị username, password, spc_f

      if (!username || !password || !spc_f) {
        message.error("Dữ liệu không hợp lệ: " + line);
        continue;
      }

      try {
        const res = await loginWithPassword(username, password, spc_f); // Gọi API
        if (res) {
          result.push({
            username,
            password,
            spc_f,
            spc_st: res.cookie, // Cookie lấy từ API trả về
            cookieFull: res.cookieFull.join("; "), // Dùng join để nối array thành chuỗi
          });
        } else {
          result.push({
            username,
            password,
            spc_f,
            spc_st: "Error",
            cookieFull: "Error",
          });
        }
      } catch (error) {
        message.error(`Lỗi khi xử lý ${username}`);
      }
    }

    setData(result); // Cập nhật dữ liệu vào bảng
    setLoading(false);
  };

  // Hàm copy vào clipboard
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Copied to clipboard!");
  };

  // Hàm cắt ngắn văn bản
  const truncateText = (text, length = 50) => {
    if (text.length > length) {
      return text.substring(0, length) + "...";
    }
    return text;
  };

  // Hàm tải xuống SPC_ST
  const downloadSPC_ST = () => {
    const spc_stData = data.map((item) => `${item.spc_st}`).join("\n");
    const blob = new Blob([spc_stData], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "spc_st.txt";
    link.click();
  };

  // Hàm tải xuống Cookie Full
  const downloadCookieFull = () => {
    const cookieFullData = data
      .map(
        (item) =>
          `${item.username}|${item.password}|${item.spc_f}|${item.cookieFull}`
      )
      .join("\n");
    const blob = new Blob([cookieFullData], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "cookie_full.txt";
    link.click();
  };

  // Cấu hình các cột cho bảng
  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      render: (text) => <span className="text-blue-600">{text}</span>,
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "SPC_F",
      dataIndex: "spc_f",
      key: "spc_f",
      render: (text) => (
        <div className="flex items-center space-x-2">
          <span>{truncateText(text)}</span>
          <Button
            type="link"
            icon={<CopyOutlined />}
            onClick={() => handleCopy(text)}
          />
        </div>
      ),
    },
    {
      title: "SPC_ST (Cookie)",
      dataIndex: "spc_st",
      key: "spc_st",
      render: (text) => (
        <div className="flex items-center space-x-2">
          <span>{truncateText(text)}</span>
          <Button
            type="link"
            icon={<CopyOutlined />}
            onClick={() => handleCopy(text)}
          />
        </div>
      ),
    },
    {
      title: "Cookie Full",
      dataIndex: "cookieFull",
      key: "cookieFull",
      render: (text) => (
        <div className="flex items-center space-x-2">
          <span className="truncate">{truncateText(text)}</span>
          <Button
            type="link"
            icon={<CopyOutlined />}
            onClick={() => handleCopy(text)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen space-y-6">
      <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
        <h2 className="text-2xl font-semibold text-gray-700">Convert SPC</h2>
        <TextArea
          rows={5}
          placeholder="Nhập dữ liệu theo định dạng: username|password|spc_f"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
        />
        <Button
          type="primary"
          onClick={handleConvert}
          loading={loading}
          disabled={!inputValue.trim()}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold"
        >
          Convert
        </Button>
      </div>

      {/* Hiển thị bảng với dữ liệu */}
      <div className="bg-white shadow-md rounded-lg p-6">
        <div className="flex space-x-4 mb-4">
          <Button
            onClick={downloadSPC_ST}
            className="bg-green-500 hover:bg-green-600 text-white font-semibold"
          >
            Download SPC_ST
          </Button>
          <Button
            onClick={downloadCookieFull}
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold"
          >
            Download Cookie Full
          </Button>
        </div>
        <Table
          dataSource={data}
          columns={columns}
          rowKey="username"
          pagination={{ pageSize: 5 }}
        />
      </div>
    </div>
  );
};

export default ConvertSPC;
